<template>
    <div class="system-logs page list-page">
        <div class="page--list" v-loading="loading">
            <div class="scroll-wrapper pd4 set--bottom-foot-padding">
                <list-tool-bar></list-tool-bar>
                <list-search-bar :show-system="false" @search.stop="handleSearch" @clear.stop="handleClearBtn" inline>
                    <el-form-item label="序号">
                        <el-input
                            v-model.trim="SP_.searchNo"
                            @keyup.native.enter.stop="handleInputEnter"
                            class="width2"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="错误内容">
                        <el-input
                            v-model.trim="SP_.searchValue"
                            @keyup.native.enter.stop="handleInputEnter"
                            class="width2"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="创建时间">
                        <el-date-picker
                            class="width1h"
                            v-model="SP_.searchStartTime"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择"
                            :picker-options="pickerOptions"
                        ></el-date-picker>
                        <span>-</span>
                        <el-date-picker
                            class="width1h"
                            v-model="SP_.searchEndTime"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择"
                            :picker-options="pickerOptions"
                        ></el-date-picker>
                    </el-form-item>
                </list-search-bar>

                <el-table :data="tableData">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <div>
                                        <p>query请求参数：</p>
                                        <json-viewer
                                            :value="JSON.parse(scope.row.query_params || '{}')"
                                            :expand-depth="5"
                                            boxed
                                            sort
                                            :show-array-index="false"
                                            copyable
                                        >
                                            <template slot="copy">
                                                <i class="el-icon-document-copy" title="复制"></i>
                                            </template>
                                        </json-viewer>
                                    </div>
                                    <div>
                                        <p>body请求参数：</p>
                                        <json-viewer
                                            :value="JSON.parse(scope.row.body_params || '{}')"
                                            :expand-depth="5"
                                            boxed
                                            sort
                                            :show-array-index="false"
                                            copyable
                                        >
                                            <template slot="copy">
                                                <i class="el-icon-document-copy" title="复制"></i>
                                            </template>
                                        </json-viewer>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <p>错误信息：</p>
                                    <div class="errormess-box">
                                        <div @click="handleCopy(scope.row.error_mess)" class="icon">
                                            <i class="el-icon-document-copy"></i>
                                        </div>
                                        {{ scope.row.error_mess  || '无' }}
                                    </div>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column label="序列" prop="id"></el-table-column>
                    <el-table-column label="IP地址" prop="ip"></el-table-column>
                    <el-table-column label="请求地址" prop="url"></el-table-column>
                    <el-table-column label="账号" prop="account"></el-table-column>
                    <el-table-column label="创建时间" prop="createTimeName"></el-table-column>
                </el-table>
            </div>

            <list-foot-bar>
                <el-pagination
                    layout="prev, next"
                    :current-page.sync="SP.pageNum"
                    :page-size="SP.pageSize"
                    :total="total"
                    prev-text="上一页"
                    next-text="下一页"
                    @size-change="handlePageSizeChange"
                    @current-change="handlePageNoChange"
                ></el-pagination>
            </list-foot-bar>
        </div>
    </div>
</template>

<script>
    import forList from '@/mixin/forList';
    import JsonViewer from 'vue-json-viewer';
    export default {
        name: 'Logs',
        mixins: [forList],
        components: { JsonViewer },
        data() {
            return {
                SP_: {
                    searchValue: '', // 账号
                    searchStartTime: '', // 开始时间
                    searchEndTime: '', // 结束时间
                    searchNo: '', // 序号
                },

                detailData: null,
                detailTitle: '输入参数',
                pickerOptions: {
                    disabledDate: this.calculateDisabledDate,
                },
            };
        },
        methods: {
            async fetchData() {
                const loading = this.$loading();

                try {
                    const res = await this.$axios({
                        url: '/api/operLogs/geterrlist',
                        method: 'post',
                        data: {
                            ...{
                                // 参数不足会报错，，
                                searchValue: '', // 搜索类容
                                searchStartTime: '', // 开始时间
                                searchEndTime: '', // 结束时间
                                searchNo: '', // 序号
                            },
                            ...this.SP,
                        },
                    });
                    if (res.code === 2000) {
                        if (res.data.errList.length < this.SP.pageSize) {
                            this.total = this.SP.pageSize * this.SP.pageNum;
                        } else {
                            this.total = this.SP.pageSize * this.SP.pageNum + res.data.errList.length;
                        }
                        const list = res.data.errList;
                        this.tableData.splice(0, this.tableData.length, ...list);

                        loading.close();
                    } else if (res.code !== 1003) throw res;
                } catch (reason) {
                    console.warn('获取数据失败', reason);
                    this.$message({
                        message: reason.msg || '获取数据失败',
                        type: 'warning',
                    });

                    loading.close();
                }
            },
            async handleCopy(errormess) {
                try {
                    await navigator.clipboard.writeText(errormess); // 写入剪贴板
                } catch (err) {
                    console.error('复制失败', err); // 处理错误情况
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .errormess-box {
        max-height: 300px;
        overflow: auto;
        padding: 30px 20px;
        background: #fff;

        color: #525252;
        font-size: 14px;
        border: 1px solid #eee;
        border-radius: 6px;
        position: relative;
    }
    .errormess-box .icon {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        color: #49b3ff;
    }
</style>
